function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f6e6ea;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -0.375)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0.375)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M20.125,18.25H2.875a3.446,3.446,0,0,1-1.437-.38A2.77,2.77,0,0,1,0,15.208V6.083A2.769,2.769,0,0,1,1.437,3.422a3.447,3.447,0,0,1,1.437-.38H5.75L8.625,0h5.75L17.25,3.042h2.875a3.449,3.449,0,0,1,1.438.38A2.769,2.769,0,0,1,23,6.083v9.125a4.009,4.009,0,0,1-.359,1.521A2.588,2.588,0,0,1,20.125,18.25ZM11.5,6.083a4.448,4.448,0,0,0-4.313,4.563A4.448,4.448,0,0,0,11.5,15.208a4.447,4.447,0,0,0,4.312-4.562A4.448,4.448,0,0,0,11.5,6.083Z"
})));

var SvgImage = function SvgImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18.25,
    viewBox: "0 0 23 18.25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image.15ac5417.svg";
export { ForwardRef as ReactComponent };